const state = {
  userDevices: [],
  exportDevices: [],
  serverTotal: 0,
  selectedDevice: null,
  templateConfig: null,
};

const getters = {
  userDevices: (state) => state.userDevices,
  exportDevices: (state) => state.exportDevices,
  selectedDevice: (state) => state.selectedDevice,
  templateConfig: (state) => state.templateConfig,
  serverTotal: (state) => state.serverTotal,
};

const actions = {
  async fetchDevices(
    { commit },
    {
      id,
      policyId = null,
      locationId = null,
      results = 10,
      page = 1,
      sortBy = "name",
      sortDesc = false,
      filter = null,
    }
  ) {
    // TODO: remove duplicity at user_id from URL and Parameter (API issue #588).
    let requestURL = `/restapi/users/${id}/devices`;
    if (policyId) requestURL += `?policyid=${policyId}`;
    if (locationId) requestURL += `?location_id=${locationId}`;

    const linkSymbol = policyId || locationId ? "&" : "?";

    const sortDir = sortDesc[0] === false ? "asc" : "desc";
    const offset = results * page - results;
    const sortkey = sortBy === "os" ? "extra_info" : sortBy;

    if (results) requestURL += `${linkSymbol}limit=${results}`;
    if (page) requestURL += `&offset=${offset}`;
    if (sortBy) requestURL += `&sortkey=${sortkey}`;
    if (sortDir) requestURL += `&sortdir=${sortDir}`;
    if (filter) requestURL += `&filter=${filter}`;

    const response = await this._vm.$http.get(requestURL);

    response.data.data = response.data.data.map((device) => {
      let extra = JSON.parse(device.extra_info);
      return {
        ...device,
        os: extra?.os.type !== undefined ? extra.os.type : "",
      };
    });

    commit("setDevices", response.data);
    commit("setServerTotal", response.data.total);
  },

  async fetchExportDevices({ commit }, { id }) {
    let requestURL = `/restapi/users/${id}/devices`;
    const response = await this._vm.$http.get(requestURL);
    commit("setExportDevices", response.data.data);
  },

  async fetchDevice({ commit, state }, { id, deviceId }) {
    const response = await this._vm.$http.get(
      `/restapi/users/${id}/devices/${deviceId}`
    );

    const index = state.userDevices.findIndex(
      (device) => device.id === response.data.id
    );

    if (index === -1) {
      commit("addDevice", response.data);
    } else {
      commit("updateDevice", { idx: index, device: response.data });
    }
    commit("setSelectedDevice", response.data);
  },

  async updateDevice({ commit }, { id, deviceId, device }) {
    const response = await this._vm.$http.post(
      `/restapi/users/${id}/devices/${deviceId}`,
      device
    );
    commit("updateDevice", response.data);
    commit("setSelectedDevice", response.data);
  },

  async fetchDeviceConfiguration({ commit }, { id }) {
    const response = await this._vm.$http.get(
      `/restapi/users/${id}/devices/config`
    );
    commit("updateDevice", response.data);
    commit("setSelectedDevice", response.data);
  },

  async updateDeviceConfiguration({ commit }, { id, deviceId, configuration }) {
    const response = await this._vm.$http.post(
      `/restapi/users/${id}/devices/${deviceId}/config/advanced`,
      { configuration }
    );
    commit("updateDevice", response.data);
    commit("setSelectedDevice", response.data);
  },

  async resetDeviceConfiguration({ dispatch }, { id, deviceId }) {
    const response = await this._vm.$http.delete(
      `/restapi/users/${id}/devices/${deviceId}/config/advanced/`
    );

    if (response.data.code === 200)
      await dispatch("devices/fetchDevice", { id, deviceId }, { root: true });
  },

  async udateDevicesDefaultPolicy(
    { commit },
    { id, policyId, deviceExceptionId }
  ) {
    const response = await this._vm.$http.post(
      `/restapi/users/${id}/devices/config/`,
      { policy_id: policyId, device_exception_id: deviceExceptionId }
    );
    return commit("udateDevicesDefaultPolicy", response.data);
  },

  async fetchDeviceConfigurationTemplate({ commit }, { id }) {
    const response = await this._vm.$http.get(
      `/restapi/users/${id}/devices/config/advanced`
    );
    commit("setTemplateConfig", response.data.configuration);
  },

  async updateDeviceConfigurationTemplate({ commit }, { id, configuration }) {
    const response = await this._vm.$http.post(
      `/restapi/users/${id}/devices/config/advanced/`,
      { configuration }
    );
    commit("updateDevice", response.data);
    commit("setSelectedDevice", response.data);
    commit("setTemplateConfig", response.data.configuration);
  },

  async resetDeviceConfigurationTemplate({ dispatch }, { id }) {
    const response = await this._vm.$http.delete(
      `/restapi/users/${id}/devices/config/advanced/`
    );
    if (response.data.code === 200) {
      await dispatch(
        "devices/fetchDeviceConfigurationTemplate",
        { id },
        { root: true }
      );
    }
  },

  async deleteDevices({ commit }, { userId, devices }) {
    const req = {};

    for (const device of devices) {
      req[`${device.id}`] = {
        method: "delete",
        path: `users/${userId}/devices/${device.id}`,
      };
    }

    const res = await this._vm.$http.post("/restapi/batch", req);
    const ids = Object.keys(res.data).map((item) => +item);
    commit("deleteDevice", ids);
  },
};

const mutations = {
  setDevices: (state, data) => (state.userDevices = data.data),
  setExportDevices: (state, data) => (state.exportDevices = data),
  setServerTotal: (state, data) => (state.serverTotal = data),
  setTemplateConfig: (state, config) => (state.templateConfig = config),
  setSelectedDevice: (state, data) =>
    (state.selectedDevice = { ...state.selectedDevice, ...data }),
  addDevice: (state, data) => state.userDevices.push(data),
  updateDevice: (state, data) =>
    (state.userDevices[`${data.idx}`] = {
      ...state.userDevices[`${data.idx}`],
      ...data.device,
    }),
  deleteDevice(state, devices) {
    for (const device of devices) {
      state.userDevices = state.userDevices.filter(
        (stateDevice) => stateDevice.id !== device
      );
    }
  },
  udateDevicesDefaultPolicy: (state) => state,
};

export default {
  namespaced: true,
  state,
  getters,
  actions,
  mutations,
};
